import * as React from 'react'
import { type LucideIcon } from 'lucide-react'

type EmptyStateProps = {
  icon: LucideIcon
  title: string
  description?: string
  action?: React.ReactNode
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <Icon className="h-12 w-12 text-streep-text-muted mb-4" aria-hidden="true" />
      <h3 className="text-lg font-medium text-streep-donker">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-streep-text-muted max-w-md">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}
